import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { prop } from '@ipfabric/utils/fp/prop';
import { triggerAnalyticsEvent } from 'app/analytics/posthogEvents';
import classNames from 'classnames';
import { Badge } from 'components/Badge/Badge';
import { Button } from 'components/Button/Button';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import { setGlobalAttributeFilters } from 'components/GlobalState/commands/setGlobalAttributeFilters';
import { useLocale } from 'containers/App/LocaleContext';
import { useState } from 'react';
import type { FC } from 'react';
import { HeaderAttributeFilterButton } from './HeaderAttributeFilterButton';
import { HeaderAttributeFilterModal } from './HeaderAttributeFilterModal';

export const HeaderAttributeFilter: FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const globalCtxProps = useGlobalStateContextSelectors({
    attributeFilters: prop('attributeFilters'),
    dispatch: prop('dispatch'),
  });
  const {
    app: {
      header: { attributeFilters: attributeFiltersMsg },
    },
  } = useLocale();

  const clearFilter = () => {
    globalCtxProps.dispatch(setGlobalAttributeFilters, {
      attributeFilters: {},
    });
  };

  const emptyFilter = Object.keys(globalCtxProps.attributeFilters).length === 0;

  return (
    <>
      {open && (
        <HeaderAttributeFilterModal
          onClose={() => {
            setOpen(false);
          }}
        />
      )}
      <div
        className={classNames(
          'inline-flex items-center',
          !emptyFilter && 'bg-blue-900',
        )}
      >
        <HeaderAttributeFilterButton
          className={classNames(emptyFilter && 'pr-4')}
          type='button'
          onClick={() => {
            setOpen(true);
            triggerAnalyticsEvent({
              eventName: 'dialog',
              data: {
                dialog_name: 'attribute_filter',
                type: 'modal',
                action: 'open',
                element: 'button',
                trigged_by: 'mouse_click',
              },
            });
          }}
        >
          <div className='flex items-center'>
            <Icon className='mr-2' glyph='fa-filter' size='sm' />
            {emptyFilter
              ? attributeFiltersMsg.addFilter
              : attributeFiltersMsg.filterActive}
            {!emptyFilter && (
              <Badge className='mx-2 bg-blue-100 text-gray-900'>
                {Object.keys(globalCtxProps.attributeFilters).length}
              </Badge>
            )}
          </div>
        </HeaderAttributeFilterButton>
        {!emptyFilter && (
          <Button
            type='button'
            variant='tertiary'
            icon='fa-xmark'
            inversed
            onClick={clearFilter}
            className='header-attribute-filter-button__close'
          />
        )}
      </div>
    </>
  );
};
